export const pushDataLayerEvent = (data: EventData): void => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};

export const pushDataLayerEventAfterOneTrust = (data: EventData): void => {
  if (window.OneTrust?.IsAlertBoxClosed()) {
    pushDataLayerEvent(data);
  } else if (window.OneTrust) {
    const domainData = window.OneTrust.GetDomainData();
    if (domainData.ConsentModel.Name !== 'opt-in') return pushDataLayerEvent(data);
    window.OneTrust.OnConsentChanged(() => {
      window.OneTrust?.OnConsentChanged(() => null);
      pushDataLayerEvent(data);
    });
  } else {
    window.OptanonWrapper = () => {
      window.OptanonWrapper = undefined;
      pushDataLayerEventAfterOneTrust(data);
    };
  }
};
